import Model from "@/models/Model"

export default class WhStockAdjustType extends Model {
    resource() {
        return "wh_stock_adjust_type"
    }
}